import prepareOptions from '../../prepareOptions';

import {
  BENZIN,
  DIESEL,
  ELEKTRO,
  ERDGAS,
  ETHANOL,
  GAS,
  HYBRID,
  OTHER,
  WASSERSTOFF,
} from './values';

export default prepareOptions([
  {
    value: BENZIN,
    label: __('carDetails.fuelType.petrol'),
  },
  {
    value: DIESEL,
    label: __('carDetails.fuelType.diesel'),
  },
  {
    value: GAS,
    label: __('carDetails.fuelType.gas'),
  },
  {
    value: ERDGAS,
    label: __('carDetails.fuelType.naturalGas'),
  },
  {
    value: ELEKTRO,
    label: __('carDetails.fuelType.electric'),
  },
  {
    value: ETHANOL,
    label: __('carDetails.fuelType.ethanol'),
  },
  {
    value: HYBRID,
    label: __('carDetails.fuelType.hybrid'),
  },
  {
    value: WASSERSTOFF,
    label: __('carDetails.fuelType.hydrogen'),
  },
  {
    value: OTHER,
    label: __('carDetails.fuelType.other'),
  },
]);
